import React from 'react';
import { useTranslation } from 'react-i18next';
import Link from '@material-ui/core/Link';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';
import TamperTesterHeader from '../../components/TamperTesterHeader';
import HistoryBack from '../../components/HistoryBack';

function Help() {
	const { t } = useTranslation();
	const theme = useTheme();

	return (
		<>
			<TamperTesterHeader />
			<Container maxWidth="sm" style={{ paddingTop: theme.spacing(2) }}>
				<HistoryBack />
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography variant="h4" component="h2" color="textPrimary">
							{t('help_screen.title')}
						</Typography>
					</Grid>
					<Grid item xs={12}>
						<Typography variant="body1">
							<strong>{t('help_screen.install_title')}</strong>
						</Typography>
						<ol>
							<li>
								<Typography variant="body1">
									{t('help_screen.install_step1')}
								</Typography>
							</li>
							<li>
								<Typography variant="body1">
									{t('help_screen.install_step2')}
								</Typography>
							</li>
							<li>
								<Typography variant="body1">
									{t('help_screen.install_step3')}
								</Typography>
							</li>
							<li>
								<Typography variant="body1">
									{t('help_screen.install_step4')}
								</Typography>
							</li>
						</ol>
					</Grid>
					<Grid item xs={12}>
						<Divider />
					</Grid>
					<Grid item xs={12}>
						<Typography variant="body1" style={{ marginBottom: '10px' }}>
							<strong>{t('help_screen.terminology')}</strong>
						</Typography>

						<Typography variant="body1" style={{ marginBottom: '15px' }}>
							<strong>{t('alerts.unauthorizedChecks')}</strong>{' '}
							{t('alerts.unauthorizedChecks_text')}
						</Typography>

						<Typography variant="body1" style={{ marginBottom: '15px' }}>
							<strong>{t('alerts.invalidChecks')}</strong>{' '}
							{t('alerts.invalidChecks_text')}
						</Typography>

						<Typography variant="body1" style={{ marginBottom: '15px' }}>
							<strong>{t('alerts.duplicateChecks')}</strong>{' '}
							{t('alerts.duplicateChecks_text')}
						</Typography>

						<Typography variant="body1">
							<strong>{t('alerts.diversionChecks')}</strong>{' '}
							{t('alerts.diversionChecks_text')}
						</Typography>
					</Grid>
					<Grid item xs={12} style={{ textAlign: 'center' }}>
						<Typography variant="body1" style={{ fontSize: '14px' }}>
							<strong>{t('help_screen.help')}</strong>
						</Typography>
						<Link
							href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL_ADDRESS}`}
							underline="always"
							variant="body1"
							style={{ fontSize: '14px' }}
						>
							help@westrock.com
						</Link>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}

export default Help;
